import { Box } from '@chakra-ui/react';
import { useContext, useEffect, useRef } from 'react';
import { NotificationContext } from 'providers/Notification';
import { GlobalContext } from 'providers/Global';
import { ReactComponent as NotificationsIcon } from 'assets/notifications-icon.svg';
import { useSeenTracker } from '../../hooks/useSeenTracker';
import NotificationPanel from '../NotificationPanel';

const NotificationBell = () => {
  const { connection: { accountId } } = useContext(GlobalContext);
  const { unreadCount, warningVisible, togglePanel, notifications, isPanelOpen, markSeen } =
    useContext(NotificationContext);
  const { trackRef } = useSeenTracker(notifications, isPanelOpen, markSeen);
  const containerRef = useRef<HTMLDivElement>(null);

  // Close panel on click outside (desktop)
  useEffect(() => {
    if (!isPanelOpen) return;

    const handleMouseDown = (e: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(e.target as Node)) {
        togglePanel();
      }
    };

    document.addEventListener('mousedown', handleMouseDown);
    return () => document.removeEventListener('mousedown', handleMouseDown);
  }, [isPanelOpen, togglePanel]);

  if (!accountId) return null;

  const badgeText = unreadCount === 0 ? null : unreadCount >= 10 ? '9+' : String(unreadCount);

  return (
    <Box ref={containerRef} position="relative" cursor="pointer" onClick={togglePanel} aria-label="Notifications" style={{ marginRight: 8 }}>
      <NotificationsIcon />
      {badgeText && (
        <Box
          position="absolute"
          top="-4px"
          right="-6px"
          bg="#C40E3A"
          color="white"
          borderRadius="full"
          fontSize="10px"
          fontWeight="bold"
          minW="16px"
          h="16px"
          display="flex"
          alignItems="center"
          justifyContent="center"
          px="4px"
        >
          {badgeText}
        </Box>
      )}
      {warningVisible && (
        <Box
          position="absolute"
          bottom="-2px"
          right="-2px"
          w="8px"
          h="8px"
          bg="#EAB308"
          borderRadius="full"
          border="2px solid white"
        />
      )}
      <NotificationPanel trackRef={trackRef} />
    </Box>
  );
};

export default NotificationBell;
